import React from 'react';
import { Row, Col, Select, Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import VersionEnum from '../../../../../constants/VersionEnum';
import Broom from '../../../../../images/customIcons/broom';

const { Option } = Select;

const ContentFilters = ({
  editCampaignActive,
  currentCampaign,
  versionFilter,
  setVersionFilter,
  resolutionFilterIndex,
  setResolutionFilterIndex,
  listContentResolutions,
  clearProgressDisabled,
  showModalCleanContent
}) => {
  const { t } = useTranslation();

  return (
    <Row type="flex" justify="end" style={{ marginBottom: 20 }}>
      <Row type="flex" justify="space-between" style={{ gap: 20, marginRight: 20 }}>
        <Col>
          {(!editCampaignActive ||
            (editCampaignActive && currentCampaign.status !== 'proposal')) && (
            <Row type="flex" align="middle" style={{ gap: 12 }}>
              <span className="selectTag">{t('Version')}:</span>
              <Select
                style={{ width: 150 }}
                className="select"
                defaultValue={null}
                onChange={value => setVersionFilter(value)}
                showSearch
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option value={null}>{t('All')}</Option>
                {VersionEnum.map(item => (
                  <Option key={item.key} value={item.key}>
                    {t(item.name)}
                  </Option>
                ))}
              </Select>
            </Row>
          )}
        </Col>
        <Col>
          <Row type="flex" align="middle" style={{ gap: 12 }}>
            <span className="selectTag">{t('Resolution')}:</span>
            <Select
              style={{ width: 150 }}
              className="select"
              defaultValue={null}
              onChange={value => setResolutionFilterIndex(value)}
              value={resolutionFilterIndex}
              showSearch
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Option value={null}>{t('All')}</Option>
              {listContentResolutions &&
                listContentResolutions.map((item, index) => (
                  <Option key={index} value={index}>
                    {`${item.width} x ${item.height}`}
                  </Option>
                ))}
            </Select>
          </Row>
        </Col>
      </Row>
      <Col>
        <Tooltip
          title={
            !clearProgressDisabled()
              ? t('Clear all contents added to the campaign, clearing its progress')
              : ''
          }
        >
          <Button
            className="secondary buttonContent standard"
            onClick={showModalCleanContent}
            disabled={clearProgressDisabled()}
          >
            <Broom />
            <span style={{ marginLeft: '8px' }}>{t('Clear progress')}</span>
          </Button>
        </Tooltip>
      </Col>
    </Row>
  );
};

export default ContentFilters;
